import { render } from "./MakeADealModal.vue?vue&type=template&id=ca4fcca8&scoped=true&ts=true"
import script from "./MakeADealModal.vue?vue&type=script&lang=ts"
export * from "./MakeADealModal.vue?vue&type=script&lang=ts"

import "./MakeADealModal.vue?vue&type=style&index=0&id=ca4fcca8&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca4fcca8"]])

export default __exports__